<template>
  <section>
    <div class="botones-pagina">
      <button class="boton boton--volver" @click="volver"/>
      <button
        type="button"
        class="boton boton--cancelar"
        v-if="copia._id && editando"
        @click="cancelar"/>
      <button
        type="button"
        class="boton boton--editar"
        v-if="copia._id && !editando && copia.estado === 'rechazado'"
        @click="editar"/>
      <button
        ref="botonSiguiente"
        type="button"
        v-if="!copia._id && tabActual !== 6"
        class="boton boton--rojo"
        @click="siguiente">
        <i class="fas fa-fw fa-arrow-alt-right"/>
        <span>Guardar y seguir</span>
      </button>
      <button
        type="button"
        v-if="mostrarEnviar"
        class="boton boton--enviar"
        @click="enviar"
      />
    </div>

    <ul class="tabs">
      <li class="tabs__tab"
      :class="{'tabs__tab--active': tabActual === 0}"
      @click="tabActual = 0">Bloque 1</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 1, 'tabs__tab--active': tabActual === 1}"
      @click="tabActual = 1">Bloque 2</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 2, 'tabs__tab--active': tabActual === 2}"
      @click="tabActual = 2">Bloque 3</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 3, 'tabs__tab--active': tabActual === 3}"
      @click="tabActual = 3">Bloque 4</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 4, 'tabs__tab--active': tabActual === 4}"
      @click="tabActual = 4">Bloque 5</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 5, 'tabs__tab--active': tabActual === 5}"
      @click="tabActual = 5">Bloque 6</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 6, 'tabs__tab--active': tabActual === 6}"
      @click="tabActual = 6">Adjuntos</li>
    </ul>

    <div tabs__content>
      <seguimiento-bloque1
        v-if="tabActual === 0" ref="bloque1"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <seguimiento-bloque2
        v-if="tabActual === 1" ref="bloque2"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <seguimiento-bloque3
        v-if="tabActual === 2" ref="bloque3"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <seguimiento-bloque4
        v-if="tabActual === 3" ref="bloque4"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <formulario-final
        v-if="tabActual === 4" ref="bloque5"
        :submitted="submitted" :form="copia" :editando="editando" :indice="13" seguimiento/>
      <form-costos
        v-if="tabActual === 5" ref="bloque6"
        :submitted="submitted" :form="copia.costos" :editando="editando"/>
      <seguimiento-adjuntos
        v-if="tabActual === 6" ref="bloque7"
        :submitted="submitted" :form="copia" :editando="editando"
        @fotos-cargadas="copiarFotos" />
    </div>
  </section>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import FormularioFinal from "../formularios/comun/FormularioFinal.vue";
import FormCostos from "../formularios/comun/FormCostos.vue";
import SeguimientoBloque1 from "./bloques/SeguimientoBloque1.vue";
import SeguimientoBloque2 from "./bloques/SeguimientoBloque2.vue";
import SeguimientoBloque3 from "./bloques/SeguimientoBloque3.vue";
import SeguimientoBloque4 from "./bloques/SeguimientoBloque4.vue";
import SeguimientoAdjuntos from "./bloques/SeguimientoAdjuntos.vue";

export default {
  name: "SeguimientoForm",
  components: {
    FormularioFinal,
    FormCostos,
    SeguimientoBloque1,
    SeguimientoBloque2,
    SeguimientoBloque3,
    SeguimientoBloque4,
    SeguimientoAdjuntos,
  },
  computed: {
    seguimiento() {
      return this.$store.state.seguimiento.seguimiento;
    },
    mostrarEnviar() {
      return (!this.copia._id && this.tabActual === 6)
      || (this.copia._id && this.editando);
    },
  },
  data,
  created() {
    this.tabActual = this.copia.bloqueActual || 0;
    this.editando = this.edit;
  },
  mounted() {
    document.querySelector(".tabs").scrollLeft = 105 * this.tabActual;
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    this.$store.commit(this.$actions.resetSeguimiento);
  },
  methods: {
    cancelar,
    copiarFotos,
    editar,
    enviar,
    siguiente,
    volver,
  },
  props: {
    idPadre: String,
    consecutivo: String,
    edit: Boolean,
    index: Number,
  },
  watch: {
    seguimiento: {
      handler: seguimientoHandler,
      immediate: true,
      deep: true,
    },
  },
};

function data() {
  return {
    tabActual: 0,
    copia: null,
    submitted: false,
    editando: false,
    copiaFotos: null,
  };
}

function cancelar() {
  const clonSeguimiento = cloneDeep(this.seguimiento);
  this.copia = this.copiaFotos
    ? {
      ...clonSeguimiento,
      registroFotografico: this.copiaFotos,
    }
    : clonSeguimiento;
  this.copiaFotos = null;
  this.editando = false;
}

function copiarFotos(fotos) {
  this.copiaFotos = cloneDeep(fotos);
}

function editar() {
  this.copiarFotos(this.copia.registroFotografico);
  this.editando = true;
}

function enviar() {
  this.submitted = true;
  const bloqueActual = `bloque${this.tabActual + 1}`;
  return this.$refs[bloqueActual].$validator.validate()
    .then((valido) => {
      if (valido) {
        if (this.copia.registroFotografico.length) {
          if (isString(this.copia.registroFotografico[0])) {
            return enviarSinImagenes.call(this);
          }
          return enviarConImagenes.call(this);
        }
        return enviarSinImagenes.call(this);
      }
      return false;
    });
}

function enviarConImagenes() {
  getConsecutivo.call(this, (resp) => {
    const self = this;
    self.copia.consecutivo = resp;
    self.copia.estado = "nuevo";
    self.$store.commit(self.$actions.showModal, {
      componentName: "cargandoModal",
      params: { grande: true },
    });
    const temp = cloneDeep(self.copia);
    const fotos = temp.registroFotografico.map((foto) => {
      if (foto._id) {
        delete foto.img;
      }
      return foto;
    });
    return self.$store
      .dispatch(self.$actions.postImagen, fotos)
      .then((respImgs) => {
        temp.registroFotografico = respImgs.data;
        return temp;
      })
      .then((seguimiento) => {
        const params = { seguimiento, index: self.index };
        return self.$store.dispatch(self.$actions.guardarSeguimiento, params);
      })
      .then(() => {
        self.$toastr("success", "Formulario enviado exitosamente", "Éxito");
        return self.volver();
      })
      .finally(() => {
        self.$store.commit(self.$actions.hideModal);
      });
  });
}

function enviarSinImagenes() {
  getConsecutivo.call(this, (resp) => {
    this.copia.consecutivo = resp;
    this.copia.estado = "nuevo";
    const seguimiento = cloneDeep(this.copia);
    this.$store.commit(this.$actions.showModal, {
      componentName: "cargandoModal",
      params: { grande: true },
    });
    const params = { seguimiento, index: this.index };
    return this.$store
      .dispatch(this.$actions.guardarSeguimiento, params)
      .then(() => {
        this.$toastr("success", "Formulario enviado exitosamente", "Éxito");
        return this.volver();
      })
      .finally(() => {
        this.$store.commit(this.$actions.hideModal);
      });
  });
}

function getConsecutivo(continuar) {
  if (this.copia._id) {
    return continuar();
  }
  const { cant } = this.$store.state.seguimiento.seguimientos;
  const sufijo = `00${cant + 1}`.slice(-2);
  return this.$store.commit(this.$actions.showModal, {
    componentName: "consecutivoModal",
    params: {
      grande: true,
      consecutivo: this.consecutivo,
      sufijo,
      continuar,
    },
  });
}

function siguiente() {
  this.submitted = true;
  const bloque = `bloque${this.tabActual + 1}`;
  return this.$refs[bloque].$validator.validate()
    .then((valido) => {
      if (valido) {
        this.submitted = false;
        this.tabActual += 1;
        window.scrollTo(0, 0);
        document.querySelector(".tabs").scrollLeft += 105;
        if (this.copia.bloqueActual < this.tabActual) {
          this.copia.bloqueActual = this.tabActual;
        }
        return this.$store.commit(this.$actions.actualizarTemporales, {
          temporal: this.copia,
          index: this.index,
        });
      }
      return this.$toastr("error", "Hay campos requeridos sin completar", "Error");
    });
}

function seguimientoHandler(val) {
  if (isEmpty(val)) {
    const copiaInspector = cloneDeep(this.$store.state.usuario.usuario);
    this.copia = {
      formulario: this.idPadre,
      inspector: copiaInspector,
      funcionariosParticipantes: ["", "", ""],
      nomFuncionario: `${copiaInspector.nombre} ${copiaInspector.apellidos}`,
      cedFuncionario: copiaInspector.cedula,
      costos: {},
      registroFotografico: [],
      bloqueActual: 0,
      estado: "borrador",
    };
  } else {
    this.copia = cloneDeep(val);
  }
}

function volver() {
  const params = { idPadre: this.idPadre, consecutivo: this.consecutivo };
  this.$router.push({ name: "seguimientos", params });
}
</script>
